// ../../node_modules/.pnpm/@radix-ui+react-use-layout-effect@1.1.2_@types+react@19.2.14_react@19.2.5/node_modules/@radix-ui/react-use-layout-effect/dist/index.mjs
import * as React from "react";
var useLayoutEffect2 = globalThis?.document ? React.useLayoutEffect : () => {
};

export {
  useLayoutEffect2
};
//# sourceMappingURL=chunk-OROA335X.mjs.map